import React, {useEffect, useRef} from 'react';
import '../style/VideoPlayer.scss';
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import {Navigation} from "swiper/modules";
import leftIcon from "../assets/images/left_btn.png"
import rightIcon from "../assets/images/right_btn.png"

function VideoPlayer({title, description, videos}) {
  const swiperRef = useRef(null);

  useEffect(() => {
    if (!swiperRef.current) return;

    const swiperInstance = swiperRef.current.swiper;

    const handleSlideChange = () => {
      const videos = document.querySelectorAll("video");
      videos.forEach((video) => video.pause()); // 모든 비디오 정지
      const activeVideo = swiperInstance.slides[swiperInstance.activeIndex].querySelector("video");
      if (activeVideo) {
        activeVideo.play().catch((e) => console.error("Video play error:", e));
      }
    };

    swiperInstance.on("slideChange", handleSlideChange);
    return () => swiperInstance.off("slideChange", handleSlideChange);
  }, []);

  return (
      <div id={'VideoPlayer'}>
        <div className="section-wrapper">
          <div className="section-card">
            <div className="section-title">{title}</div>
            <div className="section-description">{description}</div>
            <div className="video-player-wrapper">
              {
                  videos.length > 1 &&
                  <img className="custom-left-button" src={leftIcon} alt={''}
                       onClick={() => swiperRef.current?.swiper?.slidePrev()}/>
              }

              <Swiper
                  ref={swiperRef}
                  navigation={{
                    nextEl: ".custom-next",
                    prevEl: ".custom-prev",
                  }}
                  modules={[Navigation]}
                  className="w-full h-full"

              >
                {videos.map((video, index) => (
                    <SwiperSlide key={index} className="video-swiper-slide">
                      <div className="video-wrapper">
                        <video
                            src={video}
                            controls
                            className="video"
                        />
                      </div>
                    </SwiperSlide>
                ))}
              </Swiper>
              {
                  videos.length > 1 &&
                  <img className="custom-right-button" src={rightIcon} alt={''}
                       onClick={() => swiperRef.current?.swiper?.slideNext()}/>
              }
            </div>
          </div>
        </div>
      </div>
  );
}

export default VideoPlayer;